import { useState, useRef, useEffect } from "react";

export const Dropdown = ({ options, selectedValue, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openAbove, setOpenAbove] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handlePosition = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        setOpenAbove(spaceBelow < 150 && spaceAbove > 150);
      }
    };

    handlePosition();
    window.addEventListener("resize", handlePosition);
    return () => window.removeEventListener("resize", handlePosition);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block w-full max-w-xs">
      <button
        ref={buttonRef}
        onClick={toggleDropdown}
        className="w-full px-4 py-2 border rounded-md text-left shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 flex justify-between items-center"
      >
        {selectedValue?.label || "Select an option"}
        <img
          src="/images/arrowUp.svg"
          alt="Arrow Icon"
          className={`h-3 w-3 transition-transform duration-200 ${
            isOpen ? "rotate-0" : "rotate-180"
          }`}
        />
      </button>

      {isOpen && (
        <ul
          className={`absolute p-2 w-full bg-white border rounded-md shadow-lg max-h-60 overflow-auto z-10 ${
            openAbove ? "bottom-full mb-2" : "top-full mt-2"
          }`}
        >
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option)}
              className="cursor-pointer select-none py-2 px-4 text-gray-900 hover:bg-gray-100"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
